import { getVideoLink } from './all';
import { sendToGA } from './analytic';
import DeviceManager from '@/components/util/deviceManager';

export function toggleExternalPopup(url: string | null, iframeSettings?: any) {
  const isMobile = DeviceManager.isMobile();
  let externalPopupUrl = url;
  if (
    url &&
    (url.includes('youtu.be') || url.includes('youtube.com') || url.includes('vimeo.com'))
  ) {
    externalPopupUrl = getVideoLink(url);
  }
  if (isMobile && url && url.endsWith('.pdf')) {
    externalPopupUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true&preview=true`;
  }

  this.setState({
    overlayOn: !this.state.externalPopupOn,
    externalPopupOn: !this.state.externalPopupOn,
    externalPopupUrl,
    markerPopupOn: false,
    iframeSettings,
  });
}

export function toggleContactPopup() {
  if (!this.state.contactPopupOn) {
    sendToGA('event', {
      eventCategory: 'Contact',
      eventAction: 'click',
      eventLabel: 'open',
    });

    sendToGA('event', {
      eventCategory: 'Lead',
      eventAction: 'open',
      eventLabel: 'contact',
    });
  }
  this.setState({
    contactPopupOn: !this.state.contactPopupOn,
    overlayOn: !this.state.contactPopupOn,
  });
}
